import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-share",
  "use": "icon-share-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-share\"><path d=\"M836.2 504.2c-16.3 0-29.5 13.2-29.5 29.5v274.9H215.9V217.8h270.2c16.3 0 29.5-13.2 29.5-29.5s-13.2-29.5-29.5-29.5H215.9c-9.5 0-18 1.2-25.2 3.6l14.7 44.9-14.7-44.9c-15.2 5-25.3 15.1-30.3 30.3-2.4 7.2-3.6 15.7-3.6 25.2v590.8c0 9.6 1.2 18 3.6 25.3 5 15.1 15.1 25.3 30.3 30.2l14.7-44.9-14.7 44.9c7.3 2.4 15.7 3.6 25.2 3.6h590.8c9.6 0 18-1.2 25.3-3.6l-14.7-44.9 14.7 44.9c15.2-4.9 25.3-15.1 30.3-30.2 2.4-7.3 3.6-15.7 3.6-25.3V533.8c-0.1-16.4-13.3-29.6-29.7-29.6z\" p-id=\"2821\" /><path d=\"M862.3 192.6c-5-15.2-15.1-25.3-30.3-30.3l-14.7 44.9 14.7-44.9c-7.3-2.4-15.7-3.6-25.3-3.6H657c-16.3 0-29.5 13.2-29.5 29.5s13.3 29.5 29.5 29.5h98.1l-282.9 283c-11.6 11.5-11.6 30.2 0 41.8 5.8 5.8 13.3 8.6 20.9 8.6 7.5 0 15.1-2.9 20.9-8.6L806.4 250c0.1-0.1 0.1-0.3 0.3-0.4V372c0 16.3 13.2 29.5 29.5 29.5s29.6-13.2 29.6-29.5V217.8c0-9.6-1.2-18-3.5-25.2z\" p-id=\"2822\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/share.svg
// module id = BDVe
// module chunks = 0